import { render } from "./chat-sidebar.vue?vue&type=template&id=67b1abd7"
import script from "./chat-sidebar.vue?vue&type=script&lang=js"
export * from "./chat-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__